<template>
	<div class="ai-section" :class="{ 'dark-theme': isDarkMode }">
		<!-- Karuzela zdjęć -->
		<div class="carousel-container">
			<div class="carousel">
				<img v-for="(slide, index) in slidesData" :key="index" :src="slide.src" :alt="'Slide ' + index"
					class="carousel-image" :class="{ active: index === currentSlide }" />
				<div class="carousel-caption" v-if="slidesData[currentSlide]">
					<h3>{{ slidesData[currentSlide].title }}</h3>
					<p>{{ slidesData[currentSlide].description }}</p>
				</div>
			</div>
			<button class="carousel-btn prev" @click="prevSlide">❮</button>
			<button class="carousel-btn next" @click="nextSlide">❯</button>
		</div>

		<!-- Sekcja Hero -->
		<div class="hero">
			<h1 class="main-title">Sztuczna Inteligencja z D4 Quality</h1>
			<div class="hero-content">
				<div class="hero-text">
					<p>
						W D4 Quality przekształcamy Twój biznes dzięki sztucznej inteligencji. Automatyzujemy procesy,
						oszczędzamy Twój czas i zwiększamy zyski – wszystko dopasowane do Twoich potrzeb.
					</p>
					<a href="/contact" class="cta-button hero-cta">Rozpocznij współpracę już dziś</a>
				</div>
				<div class="hero-image">
					<img src="@/assets/ai-image1.png" alt="Sztuczna inteligencja w akcji" class="ai-hero" />
				</div>
			</div>
		</div>

		<!-- Sekcja AI Technology -->
		<div class="ai-technology-section">
			<h2 class="section-title">Dlaczego warto wybrać AI?</h2>
			<h3 class="subtitle">Sztuczna inteligencja – nowe złoto biznesu</h3>
			<p class="section-text">
				Sztuczna inteligencja naśladuje ludzkie myślenie – uczy się, analizuje i podejmuje decyzje. Z nami
				zyskasz:
				automatyzację rutynowych zadań, precyzyjną analizę danych i prognozy rynkowe. Oferujemy kompleksowe
				wsparcie –
				od wdrożenia po szkolenia – by Twój biznes działał mądrzej i szybciej.
			</p>
		</div>

		<!-- Sekcje korzyści -->
		<div class="content-wrapper">
			<div class="section">
				<h2 class="section-title">Automatyzacja na miarę Twojej firmy</h2>
				<div class="text-image">
					<div class="text-content">
						<p class="section-text">
							Usprawniamy procesy – od obsługi klienta po zarządzanie danymi – eliminując monotonię i
							oszczędzając Twój
							czas. Skup się na rozwoju, a my zajmiemy się resztą.
						</p>
					</div>
					<div class="image-container left">
						<img src="@/assets/ai-image1.png" alt="Automatyzacja procesów" class="ai-image" />
					</div>
				</div>
			</div>

			<div class="section">
				<div class="text-image reverse">
					<div class="image-container right">
						<img src="@/assets/ai-image1.png" alt="AI w biznesie" class="ai-image" />
					</div>
					<div class="text-content">
						<p class="section-text">
							Nie potrzebujesz wiedzy technicznej – tworzymy intuicyjne rozwiązania dostosowane do Twojej
							branży. Słuchamy,
							doradzamy i wspieramy, by AI stało się Twoim codziennym atutem.
						</p>
					</div>
				</div>
			</div>

			<!-- Sekcja CTA -->
			<div class="section cta-section">
				<h2 class="section-title">Uwolnij potencjał AI z D4 Quality</h2>
				<p class="section-text">
					Zaprojektujemy dla Ciebie spersonalizowane rozwiązanie AI, które odmieni Twój biznes. Dołącz do
					liderów
					przyszłości już teraz!
				</p>
				<div class="cta-button">
					<a href="/contact" class="button">Skontaktuj się i zacznij</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AI",
	inject: ["theme"],
	data() {
		return {
			slidesData: [
				{
					src: require("@/assets/images/ai-automation.png"),
					title: "Automatyzacja Procesów",
					description: "Oszczędź czas i zwiększ efektywność swojego biznesu.",
				},
				{
					src: require("@/assets/images/team.png"), // Zastąp innymi obrazami, jeśli masz
					title: "Zespół Ekspertów",
					description: "Nasi specjaliści AI pomogą Ci w każdym aspekcie projektu.",
				},
				{
					src: require("@/assets/images/growth.png"), // Zastąp innymi obrazami, jeśli masz
					title: "Wzrost Zysków",
					description: "Twoje codzienne zadania stają się prostsze z AI.",
				},
			],
			currentSlide: 0,
		};
	},
	computed: {
		isDarkMode() {
			return this.theme && this.theme.isDarkMode;
		},
	},
	methods: {
		nextSlide() {
			this.currentSlide = (this.currentSlide + 1) % this.slidesData.length;
		},
		prevSlide() {
			this.currentSlide = (this.currentSlide - 1 + this.slidesData.length) % this.slidesData.length;
		},
	},
	mounted() {
		if (this.slidesData.length > 1) {
			setInterval(this.nextSlide, 5000); // Automatyczne przewijanie co 5 sekund
		}
	},
};
</script>

<style scoped>
.ai-section {
	padding: 60px 20px;
	max-width: 1200px;
	margin: 0 auto;
	background-color: #ffffff;
	font-family: "Arial", sans-serif;
}

/* Karuzela */
.carousel-container {
	position: relative;
	margin-bottom: 60px;
}

.carousel {
	position: relative;
	width: 100%;
	height: 500px;
	overflow: hidden;
	border-radius: 12px;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.carousel-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: 0;
	transition: opacity 0.5s ease-in-out;
}

.carousel-image.active {
	opacity: 1;
}

.carousel-caption {
	position: absolute;
	bottom: 20px;
	left: 20px;
	color: #fff;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
	background: rgba(0, 0, 0, 0.5);
	padding: 10px 20px;
	border-radius: 8px;
}

.carousel-caption h3 {
	font-size: 1.8rem;
	margin-bottom: 5px;
}

.carousel-caption p {
	font-size: 1.2rem;
}

.carousel-btn {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	background: #ff0000;
	color: #fff;
	border: none;
	padding: 12px 18px;
	font-size: 20px;
	cursor: pointer;
	border-radius: 50%;
	transition: background 0.3s ease;
}

.carousel-btn:hover {
	background: #00b4d8;
}

.prev {
	left: 15px;
}

.next {
	right: 15px;
}

/* Sekcja Hero */
.hero {
	padding: 80px 0;
	background-color: #f9f9f9;
	text-align: center;
}

.main-title {
	font-size: 3.5rem;
	font-weight: 700;
	color: #ff0000;
	margin-bottom: 30px;
	line-height: 1.2;
}

.hero-content {
	display: flex;
	align-items: center;
	gap: 40px;
	max-width: 1000px;
	margin: 0 auto;
}

.hero-text {
	flex: 1;
}

.hero-text p {
	font-size: 1.4rem;
	color: #333;
	line-height: 1.6;
	margin-bottom: 20px;
}

.hero-cta {
	display: inline-block;
	padding: 14px 30px;
	font-size: 1.1rem;
	font-weight: 600;
	color: #fff;
	background-color: #ff0000;
	border-radius: 8px;
	text-decoration: none;
	transition: background-color 0.3s ease, transform 0.3s ease;
}

.hero-cta:hover {
	background-color: #00b4d8;
	transform: translateY(-2px);
}

.hero-image {
	flex: 1;
}

.ai-hero {
	max-width: 100%;
	height: auto;
	border-radius: 12px;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

/* Sekcja AI Technology */
.ai-technology-section {
	padding: 60px 20px;
	background-color: #f5f5f5;
	text-align: center;
}

.section-title {
	font-size: 2.5rem;
	font-weight: 600;
	color: #ff0000;
	margin-bottom: 20px;
}

.subtitle {
	font-size: 1.8rem;
	color: #00b4d8;
	margin-bottom: 25px;
	font-weight: 500;
}

.section-text {
	font-size: 1.2rem;
	color: #333;
	line-height: 1.8;
	max-width: 800px;
	margin: 0 auto;
}

/* Sekcje treści */
.content-wrapper {
	margin-top: 40px;
}

.section {
	margin-bottom: 60px;
}

.text-image {
	display: flex;
	align-items: center;
	gap: 40px;
	max-width: 1000px;
	margin: 0 auto;
}

.text-image.reverse {
	flex-direction: row-reverse;
}

.text-content {
	flex: 1;
}

.image-container {
	flex: 1;
}

.ai-image {
	max-width: 100%;
	height: auto;
	border-radius: 12px;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease;
}

.ai-image:hover {
	transform: scale(1.03);
}

/* Sekcja CTA */
.cta-section {
	text-align: center;
	padding: 40px 20px;
	background-color: #f9f9f9;
	border-radius: 12px;
}

.cta-button {
	margin-top: 30px;
}

.button {
	display: inline-block;
	padding: 15px 40px;
	font-size: 1.2rem;
	font-weight: 600;
	color: #fff;
	background-color: #ff0000;
	border-radius: 8px;
	text-decoration: none;
	transition: background-color 0.3s ease, transform 0.3s ease;
}

.button:hover {
	background-color: #00b4d8;
	transform: translateY(-2px);
}

/* Ciemny motyw */
.dark-theme .ai-section {
	background-color: #1a1a1a;
}

.dark-theme .carousel,
.dark-theme .hero,
.dark-theme .cta-section {
	background-color: #2d2d2d;
}

.dark-theme .ai-technology-section {
	background-color: #252525;
}

.dark-theme .main-title,
.dark-theme .section-title {
	color: #ff0000;
}

.dark-theme .subtitle {
	color: #00b4d8;
}

.dark-theme .section-text,
.dark-theme .hero-text p,
.dark-theme .carousel-caption {
	color: #e0e0e0;
}

.dark-theme .ai-hero,
.dark-theme .ai-image,
.dark-theme .carousel {
	box-shadow: 0 8px 20px rgba(255, 255, 255, 0.1);
}

/* Responsywność */
@media (max-width: 768px) {
	.carousel {
		height: 300px;
	}

	.carousel-caption h3 {
		font-size: 1.4rem;
	}

	.carousel-caption p {
		font-size: 1rem;
	}

	.hero {
		padding: 40px 0;
	}

	.main-title {
		font-size: 2.5rem;
	}

	.hero-content,
	.text-image,
	.text-image.reverse {
		flex-direction: column;
		gap: 20px;
	}

	.hero-text p,
	.section-text {
		font-size: 1.1rem;
	}

	.section-title {
		font-size: 2rem;
	}

	.subtitle {
		font-size: 1.5rem;
	}

	.button,
	.hero-cta {
		padding: 12px 25px;
		font-size: 1rem;
	}
}
</style>